// The raised-hand mark on a tile. For the host it is a button that lowers that
// person's hand; for everyone else it is only a mark. It is the yellow hand
// emoji (Adam, 2026-10-04: "can we do a yellow hand emoji instead of a blue
// circle").

import type { JSX } from "react";

const HAND = "\u270B";

interface HandChipProps {
  readonly name: string;
  readonly onLower?: () => void;
}

export function HandChip({ name, onLower }: HandChipProps): JSX.Element {
  if (onLower) {
    return (
      <button
        type="button"
        className="handchip handchip--button"
        aria-label={`Lower ${name}'s hand`}
        title={`Lower ${name}'s hand`}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={onLower}
      >
        <span aria-hidden="true">{HAND}</span>
      </button>
    );
  }
  return (
    <span className="handchip" role="img" aria-label={`${name} has a hand raised`} title="Hand raised">
      <span aria-hidden="true">{HAND}</span>
    </span>
  );
}
